import Vue from 'vue';
import { client } from '@/store';

export default {
	namespaced: true,

	state: {
		gripprequests: {
			total: 0,
			series: [],
			categories: [],
		},
		tablecounts: [],
	},

	// sync actions
	mutations: {
		setGrippRequestData(state, value) {
			state.gripprequests = value;
		},

		setTablecounts(state, value) {
			state.tablecounts = value;
		},
	},

	actions: {
		fetchGrippRequests({ commit, state, dispatch }) {
			const query = `
				query {
					gripprequests {
						total
						series
						categories
					}
				}
			`;

			return new Promise((resolve, reject) => {
				client.query(query).then(result => {
					commit('setGrippRequestData', result.gripprequests);
					resolve(result.gripprequests);
				});
			});
		},

		fetchTableCounts({ commit, state, dispatch }) {
			const query = `
				query {
					tablecounts
				}
			`;

			return new Promise((resolve, reject) => {
				client.query(query).then(result => {
					commit('setTablecounts', result.tablecounts);
					resolve(result.tablecounts);
				});
			});
		},
	}
};
